import React, { useReducer, useEffect } from 'react';
import { Modal, ModalBody } from 'reactstrap'
import { CusButton } from '../../Components/From/Button';
import { FormattedMessage } from 'react-intl';
import PerfectScrollbar from 'react-perfect-scrollbar';
import cls from 'classnames';

function Tool__CusCategory({
  selectedItem,
  onClose,
  categoryGroup
}) {

  return (
    <Modal
      isOpen
      fade={false}
      backdrop={false}
    >
      <div className="Tool Tool__CusCategory d-flex justify-content-center align-items-center">
        <div className="Tool__CusCategory__content d-flex flex-column p-4">
          <div className="Tool__CusCategory__title">
            <FormattedMessage id="popup.category" />
          </div>
          <hr className="" />
          <div className="Tool__CusCategory__optionContent d-flex flex-column col p-0 clearfix" style={{ height: 0 }}>
            <PerfectScrollbar className="col p-0" >
              {(() => {
                if (!categoryGroup) return null;
                return categoryGroup.map((e, index) => (
                  <a
                    key={index}
                    className={cls(
                      'Tool__CusCategory__option p-2'
                    )}
                    onClick={() => {
                      if (selectedItem) {
                        selectedItem(index);
                        onClose();
                      }
                    }}
                  >
                    <div className="mb-2">{e.title}</div>
                  </a>
                ));
              })()}
            </PerfectScrollbar>
          </div>
          <div className="align-items-center justify-content-center my-2">
            <CusButton.White
              children={
                <FormattedMessage id="popup.buttonBack" />
              }
              className="btn-block py-2 addmeal-back"
              onClick={() => onClose()}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default Tool__CusCategory;
